// eslint-disable-next-line import/no-cycle
import store from '@/core/store';

/**
* @description A demo guard that will be depricated after we implement the real ones
* @param to
* @param from
* @param next
*/
const demoGuard = (to, from, next) => {
  const permissions = store.getters['auth/permissions'];
  if (store.getters['auth/isAuthenticated'] && permissions.length <= 0) {
    next();
  } else if (store.getters['auth/isAuthenticated'] && to.name !== 'login' && permissions.includes(to.name)) {
    next();
  } else if (store.getters['auth/isAuthenticated'] && to.name !== 'login' && !permissions.includes(to.name)) {
    next({ name: permissions[0] });
  } else if (!store.getters['auth/isAuthenticated'] && to.name !== 'login') {
    next({ name: 'login' });
  } else {
    next();
  }

  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
};

export default demoGuard;
